import React from 'react';
import Countdown from 'react-countdown-now';
import Snackbar from '../components/snackbar';
import '../styles/countdown.scss';

const Completionist = () => (
  <div className="countdown__times">
    <div className="countdown__time">
      <div className="countdown__digits">It &#39;s here!</div>
      <div className="countdown__unit">Welcome to PME-NA in Greenville!</div>
    </div>
  </div>
)

const renderer = ({
  days, hours, minutes, seconds, completed,
}) => {
  // console.log(days, hours, minutes);
  if (completed) {
    // Render a completed state
    return <Completionist />;
  }
  // Render a countdown
  return (
    <div className="countdown__times">
      <div className="countdown__time">
        <div className="countdown__digits"> {days}</div>
        <div className="countdown__unit">days</div>
      </div>
      <div className="countdown__time">
        <div className="countdown__digits"> {hours}</div>
        <div className="countdown__unit">hours</div>
      </div>
      <div className="countdown__time">
        <div className="countdown__digits"> {minutes}</div>
        <div className="countdown__unit">minutes</div>
      </div>
      <div className="countdown__time">
        <div className="countdown__digits"> {seconds}</div>
        <div className="countdown__unit">seconds</div>
      </div>
    </div>
  );
};
const CountdownSection = () => {
  const newDate = new Date('2018-11-15T14:00:00') - Date.now();

  return (
    <div className="content-deck countdown-section">
      <Snackbar enabled={true} />
      <div className="conference-date">
            November 15th - 18th <br />
        <span className="conference-location">Greenville, SC</span>
      </div>
      <div className="countdown">
        <Countdown
          date={Date.now() + newDate}
          renderer={renderer}
        />
      </div>
    </div>
  );
};

export default CountdownSection;



// WEBPACK FOOTER //
// ./src/sections/countdownSection.js